import React,{useState} from 'react';
//import 'contents/assets/scss/page/student.scss'
import "contents/assets/scss/page/student.scss";

//component
import PopClassHistory from "../student/_PopClassHistory";//수업 히스토리 팝업
import Paging from '../../component/Inc/Paging';
import Calendar from '../../component/Inc/Calendar';

function ClassStatistics() {  
  const [isOrderActive1, setIsOrderActive1] = useState(false);//게시글 등록일기준 정렬
  const [modalOpenClassHistory, setModalOpenClassHistory] = useState(false);//수업히스토리 팝업
  return (
    <main className="com_container p_class_statistics">
      <div className="com_center_wrap">
        <section className="com_tit_wrap">
          <h2 className='com_pg_tit icon menu1_1'>교무 통계</h2>
          <div className="com_btn_wrap">
          <button className="com_btn orange s btn_plus">수업 등록</button>
          <button className="com_btn orange s btn_plus">학생 등록</button>
          </div>
        </section>
        <section className="com_pg_container">
          <div className="box full">
            <div className="board_top">
              <select className="select">
                <option value="본사">본사</option>
              </select>
              <Calendar />
            </div>
            <table className='com_board_list'>
              <colgroup><col width="4.5%"/><col span="10" width="9.5%"/></colgroup>
              <thead>
                <tr>
                  <th>구분</th>
                  <th>배정완료</th>
                  <th>인계</th>
                  <th>중단</th>
                  <th>종료</th>
                  <th>취소</th>
                  <th>보류</th>
                  <th>배정요청</th>
                  <th>과목수</th>
                  <th>타임수</th>
                  <th>진행회차</th>
                </tr>
              </thead>
              <tbody>
              {[1,2,3,4,5,6,7,8,9].map(() => {
                return (
                <tr>
                  <td>전체</td>
                  <td>300<br/>(368T)</td>
                  <td>18<br/>(20T)</td>
                  <td>1<br/>(2T) <span className='com_red_txt'>0.3%</span></td>
                  <td>4<br/>(7T) <span className='com_red_txt'>1.3%</span></td>
                  <td>8<br/>(8T)</td>
                  <td>78</td>
                  <td>294</td>
                  <td>294</td>
                  <td>294</td>
                  <td>294</td>
                </tr>
                )
              })}
              </tbody>
            </table>
            <div className="com_board_list__top">
              <section className='com_board_search end'>
                <article className='search'>
                  <input type="search" placeholder='검색할 내용을 입력해 주세요.' className="input xs" />
                  <button className="com_btn gray ws xs icon_search"/>
                </article>
              </section>
            </div>
            <table className='com_board_list'>
              <colgroup>
                <col width="5%"/><col width="10%" span="2"/><col width="8%" span="2"/><col width="10%" span="2"/><col width="8%"/><col width="10%" span="3"/>
              </colgroup>
              <thead>
                <tr>
                  <th>No.</th>
                  <th><button onClick={() => {setIsOrderActive1(!isOrderActive1)}} className={`arrow ${isOrderActive1 ? `active` : ``}`} />등록일</th>
                  <th>학생명</th>
                  <th>과목</th>
                  <th>비고</th>
                  <th>교사명</th>
                  <th>담임명</th>
                  <th>회차</th>
                  <th>수업 (T / 기수)</th>
                  <th>첫수업 일지</th>
                  <th>수업 히스토리</th>
                </tr>
              </thead>
              <tbody>
                {[1,2,3,4,5,6,7,8].map((i,idx) => {
                  return (
                    <tr key={idx}>
                      <td>{idx + 1}</td>
                      <td>2022.08.25</td>
                      <td><button className="txt btn_link">가학생103</button></td>
                      <td>영어</td>
                      <td className='td_red'>보류</td>
                      <td>홍교사102</td>
                      <td>홍담임102</td>
                      <td>45</td>
                      <td className='td_point'>1T / 2기</td>
                      <td className='td_point'><button className="txt btn_link">보기</button></td>
                      <td className='td_point'><button className="txt btn_link" onClick={() => setModalOpenClassHistory(true)}>보기</button></td>
                    </tr>
                  )
                })}
                <tr>
                  <td>9</td>
                  <td>2022.08.25</td>
                  <td><button className="txt btn_link">가학생103</button></td>
                  <td>영어</td>
                  <td className='td_point'>준비</td>
                  <td>홍교사102</td>
                  <td>홍담임102</td>
                  <td>45</td>
                  <td className='td_red'>1T / 2기</td>
                  <td className='td_red'><button className="txt btn_link">작성하기</button></td>
                  <td className='td_point'><button className="txt btn_link" onClick={() => setModalOpenClassHistory(true)}>보기</button></td>
                </tr>
              </tbody>
            </table>
            <Paging />
          </div>
        </section>
      </div>
      <PopClassHistory open={modalOpenClassHistory} close={() => setModalOpenClassHistory(false)} />
    </main>
  );
}

export default ClassStatistics;
